import { Link } from 'react-router-dom';
import site from '@/config/site.json';
import { useTranslation } from 'react-i18next';
import { CircleHelp, Send, Mail } from 'lucide-react';
import { Logo } from './Logo';
import { useNavLinks } from '@/hooks/useNavLinks';
import { SUPPORT_URL } from './HelpButton';

export function Footer() {
  const { t } = useTranslation();
  const links = useNavLinks();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-line bg-elevated">
      <div className="mx-auto max-w-8xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="mb-10 grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <Logo size="sm" className="mb-4" />
            <p className="text-sm leading-relaxed text-content-muted">{t('footer.tagline')}</p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold">{t('footer.platform')}</h4>
            <ul className="space-y-2 text-sm text-content-secondary">
              {links.map((link) => (
                <li key={link.to}><Link to={link.to} className="transition-colors hover:text-content">{t(link.key)}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold">{t('footer.resources')}</h4>
            <ul className="space-y-2 text-sm text-content-secondary">
              <li><Link to="/topics" className="transition-colors hover:text-content">{t('nav.topics')}</Link></li>
              <li><Link to="/problems/difficulty/easy" className="transition-colors hover:text-content">{t('footer.easyProblems')}</Link></li>
              <li><Link to="/problems/difficulty/medium" className="transition-colors hover:text-content">{t('footer.mediumProblems')}</Link></li>
              <li><Link to="/problems/difficulty/hard" className="transition-colors hover:text-content">{t('footer.hardProblems')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold">{t('footer.contact')}</h4>
            <ul className="space-y-2 text-sm text-content-secondary">
              <li>
                <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 transition-colors hover:text-content">
                  <CircleHelp className="h-4 w-4" /> {t('footer.help')}
                </a>
              </li>
              <li>
                <a href="mailto:hello@sqlmaster.uz" className="inline-flex items-center gap-2 transition-colors hover:text-content">
                  <Mail className="h-4 w-4" /> hello@sqlmaster.uz
                </a>
              </li>
              <li>
                <a href={site.social.telegram} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 transition-colors hover:text-content">
                  <Send className="h-4 w-4" /> Telegram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-line pt-8 text-center text-sm text-content-muted sm:text-left">
          {/* Prerender HTML yil almashganda eskirgan bo'lishi mumkin — hydration ogohlantirishsiz */}
          <p suppressHydrationWarning>{t('footer.rights', { year })}</p>
        </div>
      </div>
    </footer>
  );
}
